import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import template from './action-hybrid-column.pug';

export class ActionHybridColumn extends ProjectionGridBaseColumn {
  constructor({
    i18n, readOnly,
  }) {
    super({
      name: 'Action',
      property: 'Recommendation/ActionHybrid',
      title: i18n.getString('ColumnName_Action') || 'Action',
      bodyClasses: ['inline-action-hybrid-column'],
      colClasses: ['col-hybrid'],
    });
    this.i18n = i18n;
    this.readOnly = readOnly;
  }

  template({
    value: {
      Opportunities,
    },
  }) {
    const { i18n, readOnly } = this;
    const entity = _.first(Opportunities);

    return template({
      i18n,
      readOnly,
      issueTypeId: entity.IssueType,
      goalValueSourceId: entity.RevenueValue && entity.RevenueValue.GoalValueSourceId,
    });
  }

  get property() {
    return {
      get: _.identity,
    };
  }
}
